import React, { useState, useEffect } from 'react';
import { adminFetch } from '../../api/client';

const API_URL = process.env.REACT_APP_API_URL || '';

const CommunitiesTab = ({ user }) => {
  const [communities, setCommunities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCommunities = async () => {
      try {
        const res = await adminFetch(
          `${API_URL}/api/admin/communities/overview`
        );
        const data = await res.json();
        if (data.success) setCommunities(data.communities);
      } catch (err) {
        console.error('Communities fetch error:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchCommunities();
  }, [user]);

  if (loading) return <p style={{ color: '#9ca3af', padding: '24px' }}>Loading communities...</p>;

  return (
    <div>
      <div style={{ display: 'grid', gap: '16px', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))' }}>
        {communities.map(c => (
          <a
            key={c.airtable_id || c.slug}
            href={`/community/${c.slug}`}
            style={{
              border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px',
              background: 'white', textDecoration: 'none', color: 'inherit',
              display: 'block', cursor: 'pointer',
              transition: 'border-color 120ms, box-shadow 120ms, transform 120ms',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = '#6366f1';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(99,102,241,0.12)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = '#e5e7eb';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <h3 style={{ margin: 0, fontSize: '16px' }}>{c.name}</h3>
              <span style={{
                padding: '2px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: 500,
                color: 'white', background: c.status === 'Active' ? '#10b981' : '#9ca3af',
              }}>
                {c.status}
              </span>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '13px' }}>
              <div>
                <span style={{ color: '#6b7280' }}>Slug: </span>
                <span style={{ fontFamily: 'monospace' }}>{c.slug}</span>
              </div>
              <div>
                <span style={{ color: '#6b7280' }}>Active members: </span>
                <span style={{ fontWeight: 600 }}>{c.active_members}</span>
              </div>
              <div>
                <span style={{ color: '#6b7280' }}>Min for matching: </span>
                <span>{c.min_active_for_matching}</span>
              </div>
              <div>
                <span style={{ color: '#6b7280' }}>Repeat after: </span>
                <span>{c.settings?.repeat_after_weeks || 52} weeks</span>
              </div>
              <div>
                <span style={{ color: '#6b7280' }}>Approval: </span>
                <span>{c.settings?.approval_mode || 'auto'}</span>
              </div>
              <div>
                <span style={{ color: '#6b7280' }}>Odd user: </span>
                <span>{c.settings?.odd_user_handling || 'skip'}</span>
              </div>
            </div>

            <div style={{ marginTop: '12px', fontSize: '12px', color: '#9ca3af' }}>
              Created: {c.created_at?.split('T')[0] || '—'}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default CommunitiesTab;
